import { useState, useEffect } from 'react';

const getTimeRemaining = (futureTime) => {
  if (!futureTime) return '';

  const parsed = Date.parse(futureTime);
  if (Number.isNaN(parsed)) return '';

  const total = parsed - Date.now();

  if (total <= 0) {
    const minutesOverdue = Math.floor(Math.abs(total) / 60000);
    if (minutesOverdue >= 1) {
      return `${minutesOverdue}m ago`;
    }
    return 'Due now';
  }

  const seconds = Math.floor((total / 1000) % 60);
  const minutes = Math.floor((total / 1000 / 60) % 60);
  const hours = Math.floor((total / 1000 / 60 / 60) % 24);
  const days = Math.floor(total / 1000 / 60 / 60 / 24);
  return `${days > 0 ? `${days}d ` : ''}${hours > 0 ? `${hours}h ` : ''}${minutes}m ${seconds}s`;
};

export default function useCountdown(nextRunTime) {
  const [countdown, setCountdown] = useState(getTimeRemaining(nextRunTime));

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown(getTimeRemaining(nextRunTime));
    }, 1000);

    return () => clearInterval(interval);
  }, [nextRunTime]);

  return countdown;
}
